import { RouteReuseStrategy, ActivatedRouteSnapshot } from "@angular/router";

/**
 * This class is used for instances when you do not want to re-use a component.
 * Then you can add data: { shouldNotReuse: true } to it on route navigation in a routing module.
 * If nothing is added we go back to the default Angular route reuse logic.
 * Which always reuses the component unless the routeConfig has changed.
 */
export class CustomRouteReuseStrategy implements RouteReuseStrategy {
	shouldReuseRoute(future: ActivatedRouteSnapshot, current: ActivatedRouteSnapshot): boolean {
		// Check if the route should be re-used
		if (future.data.shouldReuse === false) {
			return false;
		}
		// Default Angular Implementation
		return future.routeConfig === current.routeConfig;
	}

	retrieve(route: ActivatedRouteSnapshot): ActivatedRouteSnapshot | null {
		return null;
	}

	store(route: ActivatedRouteSnapshot, handle: unknown): void {
		return;
	}

	shouldAttach(route: ActivatedRouteSnapshot): boolean {
		return false;
	}

	shouldDetach(route: ActivatedRouteSnapshot): boolean {
		return false;
	}
}
